import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

// Functional component for ERP Implementation page
const ErpImplementation = () => {
  // Simulating the localization logic
  //const pathParts = window.location.pathname.split('/');
  //const loc = pathParts.length === 4 ? `in ${pathParts[pathParts.length - 1].replace(/-/g, ' ').toUpperCase()}` : '';

  //// Dynamic page title and meta descriptions
  //document.title = `Best ERP Software ${loc} | ERP Systems | Business Management Solutions - Tejaxo Software`;
  //document.querySelector('meta[name="description"]').setAttribute("content", `Tejaxo Software is a High Rated Indian ERP and BI software development company ${loc}, providing award-winning Enterprise Resource Planning (ERP) software, business management solutions, services and support.`);
  //document.querySelector('meta[name="keywords"]').setAttribute("content", `Tejaxo Software, Tejaxo ERP, ERP Software ${loc},Tejaxo BI,School ERP ${loc},School Software ${loc}`);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
    <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="row">
          <img src="/theme/img/bdimg17.JPG" alt="ERP Implementation" />
        </div>
        <br />
        <div className="row">
          <h2 className="elementor-heading-title elementor-size-default">Tejaxo Software Implementation Methodology</h2>
          <p style={{ fontWeight: 400 }}>
            Our tried and tested framework helps keep your ERP project on time and on budget. Implementing business critical software such as Enterprise Resource Planning (ERP), can be a major undertaking for any business. The software must be installed in your environment, your financial and other data must be migrated over, users must be configured at the right levels with the required permissions � and they must be trained to use the system.
          </p>
        </div>
        <br />
        <div className="row">
          <div className="col-lg-6 about-img">
            <img src="/theme/img/erp-implementation-2-768x512.jpg" alt="ERP Deployment" />
          </div>
          <div className="col-lg-6 content">
            <h2 className="elementor-heading-title elementor-size-default">ERP Deployment options</h2>
            <p style={{ fontWeight: 400 }}>
              Our consultants have practical business experience across a wide variety of technologies and industries, giving them the expertise and analytical skills necessary to understand the nuances of your business � and guide your seamless implementation.
            </p>
            <p style={{ fontWeight: 400 }}>
              The Tejaxo Software Implementation Methodology has been used across thousands of implementations and is designed to help your organisation reduce risks and achieve greater ROI, in as short a time as possible.
            </p>
          </div>
        </div>
      </div>
            </section>
        </MasterPage>
  );
};

export default ErpImplementation;
